import React, {useState, useEffect} from "react"
import { useNavigate } from "react-router-dom"
import { Row, Col, Button, message } from 'antd'
import { ArrowRightOutlined, PlusCircleOutlined } from '@ant-design/icons'
import classes from './styles.module.css'
import { useTranslation } from "react-i18next"
import HelmetComponent from '../../components/Helmet'
import Spinner from '../../components/PageComponents/Spinner'
import TitleAndSubtitleAndBtn from '../../components/PageComponents/TitleAndSubtitleAndBtn'
import { useAuth } from "../../utils/auth"
import { useUserFavoritePoints, useUserFavoriteAddOrRemovePoint } from '../../hooks/useUser'
import ViewPointsComponent from '../Exploration/viewPoints'
import type { CheckboxValueType } from 'antd/es/checkbox/Group'
import utils from '../../utils'
import CheckBoxGroup from '../../components/CheckBoxGroup'
import GlobusSvg from '../../img/svg/globus'
import {MunicipalitiesData} from '../../components/CheckBoxGroup/municipalities'


const MyFavorites: React.FC = () => {

  const auth = useAuth()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  const { isLoading, isFetching, Poises } = useUserFavoritePoints(auth.userData.id)
  
  const [pointId, setPointId] = useState<string>('')
  const { refetch: refetchAddOrRemovePois } = useUserFavoriteAddOrRemovePoint(auth.userData.id, pointId, 0)

  const [poises, setPoises] = useState<any[]>([]);
  

  const [setPoisesMarkerExploration, PoisesMarkerExploration ] = useState<any[]>([]);

  const onClickAddRemoves = (idPois: string) => {
    setPointId(idPois)
    setPoises(poises => poises.filter(todo => todo.id !== idPois))
  }

  useEffect(() => {
    // setPoises(Poises)
    if (pointId !== '') {
      refetchAddOrRemovePois()
    }
  }, [pointId])


  useEffect(() => {
    setPoises(Poises)
  }, [Poises])


  const warning = () => {
    messageApi.open({
      type: 'warning',
      content: t('Δεν βρέθηκαν αγαπημένα σημεία ενδιαφέροντος για τον δήμο αυτό'),
      duration: 2,
      style: {
        marginTop: '40vh'
      },
    });
  }


  const checkBoxLists = (list: CheckboxValueType[]) => {

    let result = utils.filterFavoritePoisesArray(Poises, list)
    
    if (result.length == 0) {
      warning()
      setPoises(Poises)
    }
    else  
      setPoises(result)
  }


  // useEffect(() => {
  //     window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  // }, [])



  if (isLoading || poises.length < 0) {
    return (<Spinner />)
  }

  return (
    <>
      {contextHolder}
      <HelmetComponent title="Τα Αγαπημένα μου" descrition="Favourites page" />
      
      <TitleAndSubtitleAndBtn title={t('Λίστα Αγαπημένων')} subTitle={t('Τα αγαπημένα μου Σημεία ενδιαφέροντος')} />
      
      <div style={{ marginBottom: 50 }}>
        
        {isFetching && <div className={classes.allScreen}>
          <div className={classes.loader}></div>
        </div>}

        { poises.length == 0
            ?
            <>
              <Row justify="center">
                <div className={classes.FavouritesSection}>

                  <PlusCircleOutlined style={{ fontSize: 38 }} />
                  <div className={classes.pointTitle}>{t('Η λίστα σου είναι κενή')}</div>
                  <div className={classes.subTitleSection}> {t('Δεν έχεις προσθέσει Αγαπημένα Σημεία Ενδιαφέροντος')}</div>
                  <div className={classes.sectionTitle}>
                    {t('Πλοηγήσου στην σελίδα Εξερεύνηση ή Διαδρομές, επίλεξε “Προσθήκη στα Αγαπημένα” στα σημεία που σε ενδιαφέρουν και θα τα βρεις εδώ συγκεντρωμένα')}
                  </div>

                </div>
              </Row>
              <div className={classes.TabsContainer}>
                <Row justify="center">
                  <Col xs={24} sm={24} md={24} lg={24} >
                    <div className={classes.center}>
                      <Button
                        size='large'
                        className={classes.FavouritesBtn}
                        onClick={() => navigate('/explorations')}>
                        {t('Εξερεύνησε Σημεία Ενδιαφέροντος')}&nbsp;&nbsp;<ArrowRightOutlined />
                      </Button>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <div className={classes.center}>
                      <Button
                        size='large'
                        className={classes.FavouritesBtn}
                        onClick={() => navigate('/routes')}>
                        {t('Εξερεύνησε Διαδρομές')}&nbsp;&nbsp;<ArrowRightOutlined />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
            :
            <>
              <br /><br />
              <Row justify="center">
                <Col xs={24} sm={24} md={12} lg={4}>
                  <div className={classes.checkBoxesContainer}>
                    <p className={classes.filters}>{t('Φίλτρα αναζήτησης')}</p>
                    <CheckBoxGroup
                      list={MunicipalitiesData}
                      title={t("Δήμος")}
                      icon={<GlobusSvg width={30} height={30} fill="#275674" />}
                      checkBoxLists={(list: CheckboxValueType[]) => checkBoxLists(list)}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} span={20}>
                <ViewPointsComponent
                    lg={24}
                    xs={24}
                    array={poises}
                    total={poises.length}
                    setPoisesMarkerExploration={PoisesMarkerExploration}
                    isAuth={true}
                    isAddOrDelete={false}
                    onClickAddRemove={(idPois) => onClickAddRemoves(idPois)}
                  />
                </Col>
              </Row>
            </>
        }
      </div>
    </>
  )
}

export default MyFavorites
